import { watchDebounced as v } from "@vueuse/core";
import { defineComponent as b, reactive as y, ref as s, computed as V, toRef as d, watch as m, resolveComponent as $, openBlock as S, createBlock as O, mergeProps as k } from "vue";
import { useIdAttribute as w, useControlAttributes as I, useValidationAttributes as g, useProxyModelValue as A } from "@onereach/ui-components-common/hooks";
import { a as z } from "./OrInputBox.vue_vue_type_script_lang-q2L7rmth.mjs";
import { O as B } from "./OrInput-DBcNZlkx.mjs";
import { _ as h } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
const C = b({
  name: "OrSearch",
  components: {
    OrInput: B
  },
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    modelValue: {
      type: void 0,
      default: void 0
    },
    variant: {
      type: String,
      default: void 0
    },
    size: {
      type: String,
      default: void 0
    },
    placeholder: {
      type: String,
      default: "Search"
    },
    debounce: {
      type: Number,
      default: 500
    }
  },
  emits: [
    "update:modelValue",
    "input",
    "keydown",
    "keyup",
    "focus",
    "blur",
    "search",
    "clear"
  ],
  expose: [
    "root",
    "clear",
    "focus",
    "blur"
  ],
  setup(e, o) {
    const a = y({
      id: w(),
      ...I(),
      ...g()
    }), n = s(), i = V(() => [
      "or-search-v3",
      ...e.variant === z.Embedded ? ["grow"] : []
    ]), l = A(d(e, "modelValue"), o.emit), u = s(e.modelValue);
    m(l, (t) => {
      u.value = t;
    }), v(u, (t) => {
      t && o.emit("search", l.value = t);
    }, {
      debounce: d(e, "debounce")
    }), m(u, (t, c) => {
      !t && c && (o.emit("search", l.value = t), o.emit("clear"));
    });
    function r() {
      var t;
      (t = n.value) == null || t.clear();
    }
    function p() {
      var t;
      (t = n.value) == null || t.focus();
    }
    function f() {
      var t;
      (t = n.value) == null || t.blur();
    }
    return {
      controlAttributes: a,
      root: n,
      rootStyles: i,
      model: l,
      draft: u,
      clear: r,
      focus: p,
      blur: f
    };
  }
});
function K(e, o, a, n, i, l) {
  const u = $("OrInput");
  return S(), O(u, k({ ref: "root" }, e.controlAttributes, {
    modelValue: e.draft,
    "onUpdate:modelValue": o[0] || (o[0] = (r) => e.draft = r),
    class: e.rootStyles,
    type: "search",
    variant: e.variant,
    size: e.size,
    placeholder: e.placeholder,
    onInput: o[1] || (o[1] = (r) => e.$emit("input", r)),
    onKeydown: o[2] || (o[2] = (r) => e.$emit("keydown", r)),
    onKeyup: o[3] || (o[3] = (r) => e.$emit("keyup", r)),
    onFocus: o[4] || (o[4] = (r) => e.$emit("focus", r)),
    onBlur: o[5] || (o[5] = (r) => e.$emit("blur", r))
  }), null, 16, ["modelValue", "class", "variant", "size", "placeholder"]);
}
const R = /* @__PURE__ */ h(C, [["render", K]]);
export {
  R as O
};
//# sourceMappingURL=OrSearch-1OFONLHk.mjs.map
